import { LocalDate } from '../../../core/model/local-date';
import { ModelBase } from '../../../core/model/model-base';
import { Money } from '../../../core/model/money';

export class ControlDataExportListItem extends ModelBase {
  companyName: string;
  incomeYear: number;
  createdAt: LocalDate;
}
